<div class="agpr-formField agpr-briefingSortByField">
    <div class="agpr-briefingSortByField-sortByDropdown" [ngStyle]="{'margin-bottom': '10px'}">
        <agpr-dropdown
            [label]="field.label"
            [options]="options"
            [(ngModel)]="selectedOption"
            (ngModelChange)="onDropdownChanged($event.value)"
        ></agpr-dropdown>
    </div>
</div>
